import { ApiQuery, SortDirections } from "~/modules/filters/types";
import { PlatformColumns } from ".";

// // // //

/**
 * DEFAULT_PLATFORM_LIST_QUERY
 * Default ApiQuery for Platform list
 */
export const DEFAULT_PLATFORM_LIST_QUERY: ApiQuery = {
    pagination: {
        page: 1,
        perPage: 100,
    },
    sort: {
        direction: SortDirections.desc,
        field: PlatformColumns.bridgedTokenMarketCapDollar,
    },
};
